import React from 'react';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../ui/select';

const EMPTY = '__empty__';

/**
 * Dropdown for the dark publish forms. Uses the Radix Select (portal) instead of
 * a native <select>, which was not selectable inside the scrolling dialogs.
 * `value === ''` means "nothing chosen" (shows the placeholder), unless an
 * option with value '' exists (then that option is shown, e.g. "Automatisch").
 */
export default function SimpleSelect({ value, onChange, options, placeholder, disabled, testId }) {
  const hasEmptyOption = options.some((o) => o.value === '');
  const internal = value === '' ? (hasEmptyOption ? EMPTY : '') : value;
  return (
    <Select
      value={internal}
      onValueChange={(v) => onChange(v === EMPTY ? '' : v)}
      disabled={disabled}
    >
      <SelectTrigger
        className="h-9 w-full bg-[#0A1628] border-transparent focus:border-[#00D9C8] text-white"
        data-testid={testId}
      >
        <SelectValue placeholder={placeholder || 'Bitte auswählen…'} />
      </SelectTrigger>
      <SelectContent className="bg-[#0A1628] border-[#1A2B42] text-white max-h-72 z-[100]">
        {options.map((o) => (
          <SelectItem
            key={o.value === '' ? EMPTY : o.value}
            value={o.value === '' ? EMPTY : o.value}
            className="focus:bg-[#00D9C8]/10 focus:text-white"
            data-testid={testId ? `${testId}-option-${o.value || 'auto'}` : undefined}
          >
            {o.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
